import React from 'react';
import './assets/css/main.css';
import App from "./App";
import { createRoot } from 'react-dom/client';

if (process.env.REACT_APP_LOG_LEVEL === "error") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
}else if(process.env.REACT_APP_LOG_LEVEL === "warn"){
  console.debug = () => {};
  console.info = () => {};
  console.log = () => {};
}else if(process.env.REACT_APP_LOG_LEVEL === "info"){
  console.debug = () => {};
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App />);


